// legacySession.js
// Claves de autenticación de la intranet (login legacy + JWT del Informe de
// Aplicaciones). Centralizado para que logout y la detección de sesiones
// incompletas siempre limpien exactamente el mismo conjunto de claves.
export const clearLegacySession = () => {
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("familyGrowersAccessToken");
  localStorage.removeItem("userName");
  localStorage.removeItem("idUsuario");
};
